import Request from "@/Request";

export function expensesList(payload) {
  return Request({
    url: "/analytics/expenses",
    method: "get",
    params: payload,
  });
}